import { Toaster as SonnerToaster } from 'sonner';

export function Toaster() {
  return (
    <SonnerToaster
      position="top-right"
      toastOptions={{
        style: {
          background: 'white',
          color: 'hsl(215, 50%, 10%)',
          border: '1px solid hsl(215, 10%, 89%)',
        },
        className: 'glass',
      }}
    />
  );
}